import { TIER_ORDER } from "./tiers.js";

/**
 * Maps TCIs to patient-facing FEATURE_GATES keys used for facility grants.
 * Keep in sync with functions/src/entitlements/tciPatientFeatures.js
 */
export const TCI_PATIENT_FEATURES = {
  "op-results-comms": ["results-comms-notify", "results-comms-detail"],
  allergies: ["allergies"],
  "op-care-gap": ["care-gap"],
};

/** Feature keys that must resolve through resolveEffectivePatientAccess. */
export const SYRUP_FEATURE_KEYS = new Set([
  "results-comms-notify",
  "results-comms-detail",
  "allergies",
  "care-gap",
  "medical-library",
]);

export const SYRUP_FEATURE_MIN_TIERS = {
  "results-comms-notify": "free",
  "results-comms-detail": "medium",
  allergies: "medium",
  "care-gap": "large",
  "medical-library": "medium",
};

export function maxTier(a, b) {
  const ai = TIER_ORDER.indexOf(a);
  const bi = TIER_ORDER.indexOf(b);
  if (ai < 0) return b || "free";
  if (bi < 0) return a || "free";
  return ai >= bi ? a : b;
}

/**
 * Combine own subscription tier with active facility grants.
 * Never reduces below own tier; honors each grant's grantedTier exactly.
 */
export function resolveEffectivePatientAccess(ownTier, activeGrants = [], now = new Date()) {
  let grantTier = null;
  for (const grant of activeGrants || []) {
    if (!grant || grant.status !== "active") continue;
    const expiresAt = grant.expiresAt;
    if (!expiresAt) continue;
    const expDate = expiresAt.toDate ? expiresAt.toDate() : new Date(expiresAt);
    if (!(expDate > now)) continue;
    const tier = grant.grantedTier;
    if (tier !== "medium" && tier !== "large") continue;
    grantTier = grantTier ? maxTier(grantTier, tier) : tier;
  }
  if (!grantTier) return ownTier || "free";
  return maxTier(ownTier || "free", grantTier);
}
